import React, { useEffect } from "react";
import referlist from "referlist";

import {
  Col,
  ContentBlock,
  Image,
  Section,
} from "../../components/shared/layout/Layout";
import {
  LargeBodyText,
  LargeHeaderText,
} from "../../components/shared/text/Text";
import Button from "../Button";
import Input from "../Input";

const Hero = (props) => {
  useEffect(() => {
    referlist.initialize({ domain: "copysmith" });
  }, []);
  return (
    <ContentBlock
      className="pt-md-5 pt-2 pb-5 pl-md-5 pr-md-5 ml-md-5 mr-md-5"
      {...props}
    >
      <Section>
        <Col width={48}>
          <LargeHeaderText>1 step content marketing.</LargeHeaderText>
          <LargeBodyText className="mt-4 text-center text-md-left">
            Spend more time doing everything else. We help you write your blog
            posts, product descriptions, ads, taglines, and SEO metadata.
          </LargeBodyText>
          <div className="d-flex w-100 mt-4 flex-column flex-md-row align-items-center">
            <div className="col-12 col-md-8 pl-0 mb-4 mb-md-0">
              <Input
                type="text"
                id="referlistemail"
                placeholder="Enter email"
                className="mr-4"
              />
            </div>
            <Button id="referlistbutton" className="col-6 col-md-4">
              Join Waitlist
            </Button>
          </div>
        </Col>
        <Col width={52}>
          <Image
            className="w-100"
            // src='https://imgur.com/x80UrvJ.png'
            src="https://imgur.com/1tztWHw.gif"
            alt="Showcase service"
            title="Workflow"
          />
        </Col>
      </Section>
    </ContentBlock>
  );
};

export default Hero;
